<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Configurazioni', route: '/backoffice/configurazioni/' }, { label: 'Modifica Configurazione', active: true }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">MODIFICA CONFIGURAZIONE</h1>
</section>

<section class="pb-16 mb-8 px-container">
    <form [formGroup]="formConfigurazione" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">                                                                
            <div class="w-full">
                <label>* Valore</label>
                <input type="text" pInputText formControlName="value" name="value" id="value" required />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formConfigurazione.get('value')?.hasError('required') && (formConfigurazione.get('value')?.dirty || formConfigurazione.get('value')?.touched)">Il valore è obbligatorio!.</small>
            </div>                                                                     
            <div class="w-full">
                <label>Descrizione <i>(opzionale)</i></label>
                <input type="text" pInputText formControlName="descrizione" name="descrizione" id="descrizione" />
            </div>                
            <div class="flex lg:flex-row flex-col gap-8">
                <div class="lg:w-1/2 w-full">
                    <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formConfigurazione.valid">Modifica configurazione</button>
                </div>
                <div class="lg:w-1/2 w-full">
                    <p-confirmPopup #confirmDeletePopupRef>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <p-button class="text-center btn-danger-backoffice p-2 w-full font-medium" (click)="onDelete()" label="Elimina" />
                                    <p-button class="text-center btn-outln-backoffice p-2 w-full font-medium" (click)="onAnnulla()" label="Annulla" />
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmPopup>
                    <button class="btn-danger-backoffice p-3 w-full font-medium" type="button" (click)="onDeleteConfigurazionePopup($event)">Elimina configurazione</button>
                </div>
            </div>    
        </div>
    </form>
</section>